import { Menu, UserRound, X } from "lucide-react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { authClient } from "../lib/auth-client";
import BrandMark from "./BrandMark";

const navItems = [
  ["Play Random", "/play"], ["Discover", "/discover"], ["Create", "/create"], ["Leaderboards", "/leaderboards"],
] as const;

export default function AppHeader() {
  const [open, setOpen] = useState(false);
  const { data: session } = authClient.useSession();
  const isAccount = Boolean(session?.user && !session.user.isAnonymous);
  return (
    <header className="site-header">
      <div className="header-inner">
        <NavLink to="/" className="brand-link" onClick={() => setOpen(false)}><BrandMark /></NavLink>
        <nav className={open ? "primary-nav is-open" : "primary-nav"} aria-label="Primary navigation">
          {navItems.map(([label, path]) => <NavLink key={path} to={path} onClick={() => setOpen(false)}>{label}</NavLink>)}
          <NavLink className="mobile-only" to="/dashboard" onClick={() => setOpen(false)}>Your puzzles</NavLink>
        </nav>
        <div className="header-actions">
          <NavLink className="button button-ghost sign-in" to={isAccount ? "/settings" : "/sign-in"}><UserRound size={18} /> {isAccount ? "Account" : "Sign in"}</NavLink>
          <button className="menu-button" type="button" aria-expanded={open} aria-label={open ? "Close navigation" : "Open navigation"} onClick={() => setOpen((value) => !value)}>{open ? <X /> : <Menu />}</button>
        </div>
      </div>
    </header>
  );
}
